import type { IconConfig, IconProps } from './Icon';
import Icon from './Icon';

export type { IconConfig, IconProps };
export default Icon;
